export default __webpack_public_path__ + "static/media/fNeutral21.bb5d8762.png";